<template>
  <GoogleMapLoader
    :mapConfig='mapConfig'
    :apiKey='apiKey'
  ><template slot-scope="{ google, map }">
          <GoogleMapMarker
            v-on="crosswalk"
            :key="crosswalk._id"
            :marker="marker(crosswalk)"
            :google="google"
            :map="map"
          />
        </template>
  </GoogleMapLoader>
</template>

<script>
import { mapSettingsDetail } from '@/consts/mapSettingsDetail';
import GoogleMapLoader from './GoogleMapLoader.vue';
import GoogleMapMarker from './GoogleMapMarker.vue';

export default {
  props: {
    crosswalk: {
      type: Object,
      required: true,
    },
  },
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },

  data() {
    return {
      apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    };
  },

  computed: {
    mapConfig() {
      return {
        ...mapSettingsDetail,
        center: this.mapCenter,
      };
    },
    mapCenter() {
      return { lat: this.crosswalk.lat, lng: this.crosswalk.lng };
    },
  },
  methods: {
    marker(crossing) {
      const pos = { lat: crossing.lat, lng: crossing.lng };
      const ttl = crossing.displayName;
      const pri = crossing.riskLevel;
      const objId = crossing._id;
      return {
        position: pos,
        title: ttl,
        priority: pri,
        id: objId,
      };
    },
  },
};
</script>
<style>
</style>
